export const SERVICE = 'COMPANIES'
